import React from 'react';

import MediaPlayer from '../../components/player/MediaPlayer';
import { IMAGE, AUDIO, VIDEO } from '../../constants/fileTypes';

type FileType = string;

interface FilePreviewProps {
  type: FileType;
  url: string;
  text?: string;
  name?: string;
}

const FilePreview: React.FC<FilePreviewProps> = ({ type, url, text, name }) => {
  const openFile = () => window.open(url);

  switch (type) {
    case IMAGE:
      return (
        <a
          className="message-img"
          target="_blanc"
          aria-label={text}
        >
          <img style={{ cursor: 'pointer' }} src={url} alt={name || "message-file"} onClick={openFile} />
        </a>

      );
    case AUDIO:
      return (
        <MediaPlayer isAudio src={url} text={text} />
      );
    case VIDEO:
      return (
        <MediaPlayer isVideo src={url} text={text} />
      );
    default:
      return null;
  }
};

export default FilePreview;
